/* eslint-disable import/no-anonymous-default-export */
import Authentication from "pages/Authentication"
import Cart from "pages/Cart"
import Checkout from "pages/Checkout"
import Contact from "pages/Contact"
import Faq from "pages/Faq"
import Faqs from "pages/Faqs"
import Home from "pages/Home"
import Login from "pages/Login"
import OrderComplete from "pages/OrderComplete"
import Page404 from "pages/Page404"
import Privacy from "pages/Privacy"
import Privacypolicy from "pages/Privacypolicy"
import ProductDetail from "pages/ProductDetail"
import Products from "pages/Products"
import Shipping from "pages/Shipping"
import Signup from "pages/Signup"
import Terms from "pages/Terms"
import Whower from "pages/Whower"
import Wishlist from "pages/Wishlist"
import MyAccount from "pages/MyAccount"
import OrderDetailsPage from "components/OrderDetails"

const publicRoutes = [
    { path: "*", component: Page404 },
    { path: '/', component: Home },
]

const protectedRoutes = [
    { path: "/signup", component: Signup },
    { path: "/who-we-are", component: Whower },
    { path: "/Privacy", component: Privacy },
    { path: "/terms-condition", component: Terms },
    { path: "/Authentication", component: Authentication },
    { path: "/Faq", component: Faq },
    { path: "/Shipping", component: Shipping },
    { path: "/Contact", component: Contact },
    { path: "/login", component: Login },
    { path: "/products", component: Products },
    { path: "/products/:id", component: ProductDetail },
    { path: "/cart", component: Cart },
    { path: "/checkout", component: Checkout },
    { path: "/order-complete", component: OrderComplete },
    { path: "/wishlist", component: Wishlist },
    {path :"/faqs",component : Faqs},
    {path :"/privacy-policy",component : Privacypolicy},
    {path :"/profile",component : MyAccount},
    {path :"/orders-details/:id",component:OrderDetailsPage}
]



export default { publicRoutes, protectedRoutes }